<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择行项"
      width="1200px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sapPurchaseOrders">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购单号：">
            <el-input v-model.trim="filter.buyOrderNo" type="textarea" placeholder="请输入采购单号" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="buyOrderNo" align="center" label="采购订单号" min-width="180"/>
      <el-table-column prop="gysName" align="center" label="供应商" min-width="180"/>
      <el-table-column prop="gysCode" align="center" label="供应商编号" min-width="180"/>
      <el-table-column prop="addDate" align="center" label="创建日期" min-width="180"/>
      <el-table-column prop="statusName" align="center" label="接收状态" min-width="180"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="select(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "PurchaseOrderSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          buyOrderNo: "",
          gysName: "",
          buyUserName: "",
          receiveStatus: -1,
          managerID: -1,
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      select(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>